var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import InputFeedback from "../Feedback/InputFeedback";
import { classNames } from "../../Util";
var Field = function (_a) {
    var id = _a.id, displayName = _a.displayName, error = _a.error, tip = _a.tip, after = _a.after, inputEl = _a.inputEl, _b = _a.exclamationPadding, exclamationPadding = _b === void 0 ? "pr-3" : _b, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, _d = _a.withExclamationIcon, withExclamationIcon = _d === void 0 ? true : _d;
    return (_jsxs("div", { children: [!hideLabel
                ? _jsx("label", __assign({ htmlFor: id, className: "block text-sm font-medium text-gray-700" }, { children: displayName }))
                : _jsx(_Fragment, {}), _jsxs("div", __assign({ className: classNames("relative rounded-md shadow-sm", hideLabel ? "" : "mt-1") }, { children: [inputEl, error && withExclamationIcon &&
                        _jsx("div", __assign({ className: classNames("pointer-events-none absolute inset-y-0 right-0 flex items-center z-10", exclamationPadding) }, { children: _jsx(ExclamationCircleIcon, { className: "h-5 w-5 text-red-500", "aria-hidden": "true" }) }))] })), after && after, _jsx(InputFeedback, { type: "tip", message: tip }), _jsx(InputFeedback, { type: "error", message: error })] }));
};
export default Field;
